import dayjs from 'dayjs';
import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { getDaysDifference } from '../../../utils/dateCalculations';
import styles from './Weeks.module.scss';

export const Weeks = () => {
  const schoolYear = useSelectedSchoolYear();
  const start = dayjs(schoolYear?.start);
  const end = dayjs(schoolYear?.end);
  const totalDays = getDaysDifference(start, end);

  // ISO-Kalenderwochen aus den echten Datumswerten iterieren. cursor.isoWeek()
  // liefert die KW automatisch inkl. 53 in den betreffenden Jahren; erste/letzte
  // Woche werden über die echte Tagesüberlappung korrekt als Teilwoche schmaler.
  const weeks: { kw: number; widthPercent: number; days: number }[] = [];
  let cursor = start;
  while (cursor.isSameOrBefore(end, 'day')) {
    const weekEnd = cursor.endOf('isoWeek');
    const segmentEnd = weekEnd.isAfter(end) ? end : weekEnd;
    const days = getDaysDifference(cursor, segmentEnd);
    weeks.push({
      kw: cursor.isoWeek(),
      widthPercent: (days / totalDays) * 100,
      days,
    });
    cursor = weekEnd.add(1, 'day');
  }

  return (
    <div className={styles.weeks}>
      {weeks.map(({ kw, widthPercent, days }, index) => (
        <div key={index} className={styles.week} style={{ width: `${widthPercent}%` }}>
          {/* Teilwochen (Anfang/Ende, < 7 Tage) sind zu schmal -> Label weglassen statt abschneiden */}
          {days === 7 ? kw : ''}
        </div>
      ))}
    </div>
  );
};
